import React, { Component } from 'react';
import _ from 'lodash';
import queryString from 'query-string';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Grid, Button, IconButton, withStyles } from '@material-ui/core';
import {
  Save as SaveIcon,
  MoreVert as MoreVertIcon,
  Lock as LockIcon,
} from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { Prompt } from 'react-router-dom';

import RecoveryPrice from 'views/RecoveryPrice';
import { FormField2 as Field, MenuCustom } from 'components';
import ProjectDetails from './components/ProjectDetails';
import SiteDetails from './components/SiteDetails';
import CalculatedResults from './components/CalculatedResults';
import MaterialChooser from './components/MaterialChooser';
import CoefficientTable from './components/CoefficientTable';
import CalculatedTable from './components/CalculatedTable';
import CorrectionValues from './components/CorrectionValues';
import {
  getTypes,
  valueChanged,
  resetForm,
  getProjects,
  saveForm,
  getRecord,
  getReport,
  updateForm,
} from './_actions';
import { getExcelExport } from 'services/ntk';

import {
  confirmDialog,
  getCurrentAccount,
  b64toBlob,
  blobToFileDownload,
  toast,
} from 'utils/helpers';
import { history } from 'utils/history';
import api from 'utils/api';
import { EDU_MODE } from 'utils/config';

const SERVICE_CODE = 'ntk';

// Component styles
const styles = () => ({
  root: {
    padding: '0px'
  },
  item: {
    height: '100%'
  }
});

class RecoveryPriceForm extends Component {
  state = {
    showTrialMessage: false,
    showSummaryAlert: true,
  };

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(resetForm());
  }

  componentWillUnmount() {
    // Remove the page leave listener
    // window.removeEventListener('beforeunload', this.beforeunload.bind(this));
  }

  componentDidMount() {
    if (_.includes(getCurrentAccount().trialServices, SERVICE_CODE)) {
      this.setState({ showTrialMessage: true });
    }

    // Listen for page leave attempt
    // window.addEventListener('beforeunload', this.beforeunload.bind(this));

    const { dispatch, match } = this.props;
    const recordId = match.params.id;
    if (recordId) {
      dispatch(getRecord(recordId));
    } else {
      const projectId = queryString.parse(this.props.location.search, {
        ignoreQueryPrefix: true
      }).project;

      dispatch(getProjects(projectId));
      dispatch(getTypes());
    }
  }

  getWallTypes() {
    const { record } = this.props;

    if (!record.materials) {
      return;
    }

    // TOTO is this {type: 'Sienos'} multilanguage proof?
    const materialGroup = _.find(record.materials, { type: 'Sienos' });
    if (!materialGroup) {
      return;
    }

    const wallMaterials = materialGroup.values.join(', ').split(', ');

    return wallMaterials;
  }

  handleChange({ name, value }) {
    if (!name) {
      return;
    }

    const { dispatch } = this.props;
    dispatch(valueChanged({ name, value }));
  }

  beforeunload(e) {
    const { record } = this.props;

    if (record.amount) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  handleRecalcVersion() {
    const { record } = this.props;

    history.push(`/recovery-price/${record._id}/clone`);
  }

  async handleClone() {
    const { record, t } = this.props;

    if (!window.confirm(t('Ar tikrai norite sukurti kopiją?')))
      return;

    try {
      await api.post(`/services/recovery-price/${record._id}/clone`);

      if (!!record?.estimateSummary) {
        window.open(`/projects/${record.project}/dashboard`, '_blank').focus();
      } else history.push(`/projects/${record.project}/dashboard`);
    } catch (err) {
      console.error(err);
      window.alert(t('Nepavyko sukurti kopijos.'));
    }
  }

  handleBackToSummary() {
    const { record } = this.props;
    history.push(`/projects/${record.project}/summaries/${record.estimateSummary}`);
  }

  async handleDelete() {
    const { record, t } = this.props;

    if (!window.confirm(t('Ar tikrai norite pašalinti šį skaičiavimą?')))
      return;

    try {
      await api.delete(`/services/recovery-price/${record._id}`);

      history.push('/recovery-price/');
    } catch (err) {
      console.error(err);
      window.alert(
        t(
          'Nepavyko pašalinti. Patikrinkite, ar tikrai turite teises šalinti šį įrašą.'
        )
      );
    }
  }

  handleClearForm() {
    const { dispatch, record, t } = this.props;

    if (confirmDialog(t('Ar tikrai norite išvalyti skaičiavimo duomenis?'))) {
      dispatch(resetForm());
      dispatch(getProjects(record.project));
      dispatch(getTypes());

      if (record._id) {
        // Restore ID if existing record
        dispatch(valueChanged({ name: '_id', value: record._id }, true));
      }
    }
  }

  handlePrintReport = async (fileType) => {
    const { dispatch, record, t } = this.props;

    const printOptions = {
      type: 'calculationReport',
      params: ['id'],
      values: [record._id],
      fileType: fileType,
    };

    try {
      dispatch(getReport(printOptions));

      toast(t('Dokumentas ruošiamas'), 'info');
    } catch (err) {
      console.error(err);
      window.alert(t('Įvyko klaida'));
    }
  }

  handleCreatedNewProject(newId) {
    this.props.dispatch(getProjects());

    if (newId) {
      const self = this;
      setTimeout(function () {
        self.handleChange({ name: 'project', value: newId });
      }, 2000);
    }
  }

  handleSaveForm() {
    const { dispatch, record } = this.props;

    if (record._id) {
      dispatch(updateForm());
    } else {
      dispatch(saveForm());
    }
  }

  async handleExport() {
    const { t } = this.props;

    try {
      const {
        record,
        data: { currentProject },
        data
      } = this.props;
      const { doc: base64Response, filename } = await getExcelExport({
        record,
        currentProject,
        allMaterials: data.materials
      });

      const blob = b64toBlob(
        base64Response,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );

      blobToFileDownload(`${_.snakeCase(filename)}.xlsx`, blob);
    } catch (err) {
      window.alert(t('Nenumatyta klaida eksportuojant'));
    }
  }

  async handleReadonly(isReadonly) {
    const { record, dispatch, t } = this.props;
    if (!window.confirm(t(`Ar tikrai norite ${isReadonly ? 'leisti' : 'neleisti'} redaguoti šį skaičiavimą?`))) return;

    try {
      await api.post(`/services/recovery-price/${record._id}/readonly`, { isReadonly });

      toast(t('Atnaujinta'), 'success');

      dispatch(getRecord(record._id));
    } catch (err) {
      console.error(err);
      toast(t('Nepavyko suformuoti'), 'error');
    }
  }

  async handleArchive(isArchived) {
    const { record, dispatch, t } = this.props;
    if (!window.confirm(t(`Ar tikrai norite ${isArchived ? 'archyvuoti' : 'iškelti iš archyvo'} šį skaičiavimų objektą?`))) return;

    try {
      await api.post(`/services/recovery-price/${record._id}/archive`, { isArchived });

      toast(t('Atnaujinta'), 'success');

      if (isArchived == true) {
        history.push(`/projects/${record.project}/dashboard`);
      } else dispatch(getRecord(record._id));
    } catch (err) {
      console.error(err);
      toast(t('Nepavyko atnaujinti'), 'error');
    }
  }

  renderContent() {
    const {
      classes,
      data,
      record,
      showMaterials,
      skipMaterials,
      showResults,
      isLoadingRecord,
      t
    } = this.props;

    return (
      <div
        className={classes.root}
        style={{ marginTop: '-10px', maxWidth: '1200px' }}>
        {!record.isReadonly && <Prompt
          when={record.amount}
          message={(location, action) => {
            // Prevents showing confirmation when no navigation out of record scope
            return location.pathname.startsWith('/recovery-price/')
              ? true
              : t(
                'Ar tikrai norite išeiti iš skaičiavimo? Neišsaugoti duomenys bus prarasti.'
              );
          }}
        />
        }

        <Grid container spacing={2}>
          {record.pricing && record.type && (record.buildingType || record.isReadonly) ? (
            <Grid item sm={12} style={{ textAlign: 'right' }}>
              {!!record?.isReadonly &&
                <div style={{
                  display: 'inline-block',
                  height: '25px',
                  padding: '2px 10px',
                  backgroundColor: '#2196F3',
                  borderRadius: '4px',
                  color: '#fff',
                  verticalAlign: 'middle',
                }}>
                  <LockIcon style={{ verticalAlign: 'text-top' }} /> {t('Peržiūros rėžimas')}
                </div>
              }

              {!record.isReadonly &&
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={this.handleSaveForm.bind(this)}
                // className={classes.resetButton}
                >
                  {t('Išsaugoti')}
                </Button>
              }

              {!!record._id && (
                <MenuCustom
                  buttonText={t('Veiksmai')}
                  endIcon={<MoreVertIcon />}
                  buttonVariant="contained"
                  buttonColor="primary"
                  items={!record.isReadonly ? 
                    [
                      { label: t('Išvalyti skaičiavimo duomenis'), handler: this.handleClearForm.bind(this) },
                      { label: t('Pašalinti skaičiavimą'), handler: this.handleDelete.bind(this) },
                      { label: t('Perskaičiuoti kita kainų versija'), handler: this.handleRecalcVersion.bind(this) },
                      { label: t('Sukurti kopiją'), handler: this.handleClone.bind(this) },
                      { label: t('Spausdinti (PDF)'), handler: () => this.handlePrintReport('PDF') },
                      { label: t('Spausdinti (Excel)'), handler: () => this.handlePrintReport('XLSX') },
                      { label: t('Archyvuoti'), handler: () => this.handleArchive(true) },
                      { label: t('Neleisti redaguoti'), handler: () => this.handleReadonly(true) },
                    ] : record.isArchived ? 
                    [
                      { label: t('Pašalinti skaičiavimą'), handler: this.handleDelete.bind(this) },
                      { label: t('Iškelti iš archyvo'), handler: () => this.handleArchive(false) }
                    ] : [{ label: t('Leisti redaguoti'), handler: () => this.handleReadonly(false) }]
                  }
                  style={{ marginLeft: 10, height: "25px" }}
                />
              )}
            </Grid>
          ) : null}

          {/* <Grid item sm={12}>
            <ProjectDetails
              projects={data.projects}
              currentProject={data.currentProject}
              isCollapsed={isLoadingRecord || data.currentProject != null}
              handleChange={this.handleChange.bind(this)}
              onCreatedNewProject={value => this.handleCreatedNewProject(value)}
            />
          </Grid> */}

          <Grid item sm={5}>
            <SiteDetails
              handleChange={this.handleChange.bind(this)}
              handleClearForm={this.handleClearForm.bind(this)}
              handleSaveForm={this.handleSaveForm.bind(this)}
              types={data.types}
              versions={data.versions}
              hierarchy={data.hierarchy}
              project={record.project}
              title={record.title}
              description={record.description}
              type={record.type}
              buildingType={record.buildingType}
              unit={record.unit}
              amount={record.amount}
              pricing={record.pricing}
              estimateSummary={!!record?.estimateSummary}
              style={{ display: data.currentProject ? 'block' : 'none' }}
              disabled={record.isReadonly}
            />
          </Grid>

          <Grid item sm={7}>
            {showMaterials ? (
              <MaterialChooser
                materials={data.materials}
                initialMaterials={data.initialMaterials}
                recordMaterials={record.materials}
                handleChange={this.handleChange.bind(this)}
                isReadonly={record.isReadonly}
              />
            ) : null}
          </Grid>

          <Grid item sm={5}>
            {(showMaterials || skipMaterials) && showResults ? (
              <div>
                <CorrectionValues
                  corrections={record.corrections}
                  handleChange={this.handleChange.bind(this)}
                  disabled={record.isReadonly}
                />

                <CoefficientTable
                  coefficients={record.coefficients}
                  handleChange={this.handleChange.bind(this)}
                  disabled={record.isReadonly}
                />
              </div>
            ) : null}
          </Grid>
          <Grid item sm={7}>
            {(showMaterials || skipMaterials) && showResults ? (
              <CalculatedResults
                totals={record.totals}
                unit={record.unit}
                wallType={record.wallType}
                type={record.type}
                usageStartDate={record.usageStartDate}
                handleChange={this.handleChange.bind(this)}
                wallTypes={this.getWallTypes()}
                buildingType={record.buildingType}
                disabled={record.isReadonly}
              />
            ) : null}
          </Grid>
          <Grid item sm={12}>
            {(showMaterials || skipMaterials) &&
              showResults &&
              record.percents.length ? (
              <CalculatedTable
                percents={record.percents}
                totals={record.totals}
                unit={record.unit}
                handleChange={this.handleChange.bind(this)}
                disabled={record.isReadonly}
              />
            ) : null}
          </Grid>

          {record.pricing && record.type && record.buildingType ? (
            <>
              <Grid item sm={5}>
                {record._id && (
                  <div>
                    <Button
                      // size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() => this.handlePrintReport('PDF')}
                    // className={classes.resetButton}
                    >
                      {t('Spausdinti (PDF)')}
                    </Button>

                    <Button
                      style={{ marginLeft: 10 }}
                      // size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() => this.handlePrintReport('XLSX')}
                    // className={classes.resetButton}
                    >
                      {t('Spausdinti (Excel)')}
                    </Button>
                  </div>
                )}
              </Grid>
              <Grid item sm={7} style={{ textAlign: 'right' }}>
                {!record.isReadonly &&
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={this.handleSaveForm.bind(this)}
                  // className={classes.resetButton}
                  >
                    {t('Išsaugoti')}
                  </Button>
                }

                {!record.isReadonly && 
                  <Button
                    style={{ marginLeft: 10 }}
                    variant="outlined"
                    color="primary"
                    onClick={this.handleClearForm.bind(this)}
                    // className={classes.resetButton}
                    disabled={!!record?.estimateSummary}
                  >
                    {t('Išvalyti skaičiavimo duomenis')}
                  </Button>
                }

                {record._id && (
                  <Button
                    style={{
                      marginLeft: 10,
                      backgroundColor: '#dc004e',
                      color: '#ffffff'
                    }}
                    variant="contained"
                    size="small"
                    onClick={this.handleDelete.bind(this)}
                  // className={classes.resetButton}
                  >
                    {t('Pašalinti skaičiavimą')}
                  </Button>
                )}
              </Grid>
            </>
          ) : null}
        </Grid>
      </div>
    );
  }

  renderTrialMessage() {
    const { t } = this.props;

    return EDU_MODE ? null : (
      <div style={{ margin: 10 }}>
        <Alert
          variant="filled"
          severity="info"
        // onClose={() => this.setState({ showTrialMessage: false })}
        >
          {t('Jūs naudojate bandomąją (laikinai nemokamą) paslaugos versiją.')}
        </Alert>
      </div>
    );
  }

  render() {
    const { isLoading, record, data, t } = this.props;
    const { isTrial, showTrialMessage } = this.state;
    let beforeMainContentMessage = !isTrial && showTrialMessage && this.renderTrialMessage();
    if (!!record?.estimateSummary && this.state.showSummaryAlert) {
      beforeMainContentMessage = (
        <Alert
          dissmissible
          variant="standard"
          severity="info"
          style={{ margin: '10px 32px 6px' }}
          className="estimate-summary-alert"
          onClose={() => this.setState({ showSummaryAlert: false })}
        >
          {t('Atkuriamosios vertės skaičiavimas atsinaujina po objekto išsaugojimo')}
        </Alert>
      );
    }

    return (
      <RecoveryPrice
        // title={t('Atkuriamoji vertė')}
        isContentLoading={isLoading}
        breadcrumbs={[
          { title: t('Projektai'), to: '/projects' },
          { title: data?.currentProject?.title || '-', to: `/projects/${record.project}/dashboard` },
          { title: t('Atkuriamosios vertės skaičiavimai') },
          { title: record._id ? record.title || '-' : t('Naujas skaičiavimas') }
        ]}
        breadcrumbsObject={!!record._id && !!record?.estimateSummary && (
          <>
            <Button
              variant="contained"
              color="secondary"
              style={{ marginRight: 10 }}
              onClick={() => this.handleBackToSummary()}
            >
              {t('Grįžti į suvestinį skaičiavimą')}
            </Button>
          </>
        )}
        beforeMainContent={beforeMainContentMessage}
        titleComponent={!!record._id && (
          <Grid container spacing={2}>
            <Grid item style={{ width: '260px' }}>
              <div style={{ display: 'flex' }}>
                <Field
                  name="title"
                  onChange={this.handleChange.bind(this)}
                  value={record?.title}
                  label={t('Skaičiavimų objekto pavadinimas')}
                  labelColor="#0767DB"
                  shrink
                  disabled={!!record?.estimateSummary || record.isReadonly}
                  style={{ width: 220 }}
                />
                <IconButton
                  color="primary"
                  onClick={this.handleSaveForm.bind(this)}
                  style={{ marginTop: 10 }}
                  size="small"
                  disableFocusRipple={true}
                  disableRipple={true}
                  disabled={record.isReadonly}
                >
                  <SaveIcon style={{ width: 28, height: 28 }} />
                </IconButton>
              </div>
            </Grid>
          </Grid>
        )}
      >
        {this.renderContent()}
      </RecoveryPrice>
    );
  }
}

const mapStateToProps = ({ recoveryPriceForm, dispatch }) => {
  return {
    ...recoveryPriceForm,
    dispatch
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
  withTranslation()
)(RecoveryPriceForm);
